import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";

const Cart = () => {
  const { cartItems, addToCart, removeFromCart } = useCart();
  const [instructions, setInstructions] = useState("");

  const handleIncrease = (item) => {
    addToCart({ ...item, quantity: 1 });
  };

  const handleDecrease = (item) => {
    if (item.quantity > 1) {
      addToCart({ ...item, quantity: -1 });
    } else {
      removeFromCart(item.id);
    }
  };

  const handleRemove = (id) => {
    removeFromCart(id);
  };

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  // Set delivery fee to 0
  const deliveryFee = 0;
  const total = subtotal + deliveryFee;

  return (
    <div className="max-w-4xl mx-auto mt-12 mb-12 p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-bold mb-6 flex items-center gap-3">
        🛒 Your Cart
      </h1>

      {/* Cart Items or Empty Message */}
      {cartItems.length === 0 ? (
        <p className="text-gray-500 text-center py-10">Your cart is empty.</p>
      ) : (
        <div className="space-y-6">
          {cartItems.map((item) => {
            // Main image
            const mainImage = Array.isArray(item.images) && item.images.length
              ? item.images[0]
              : item.image;

            return (
              <div
                key={item.id}
                className="flex flex-row flex-wrap items-center justify-between border-b pb-6"
              >
                {/* Image on the left */}
                <div className="flex-shrink-0 flex items-center justify-center bg-[#F5F5F5] w-24 h-24 rounded-lg mr-6 p-2">
                  <img
                    src={mainImage}
                    alt={item.name}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>

                {/* Details and controls */}
                <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
                  <div className="sm:flex-1">
                    <h2 className="text-xl font-semibold">{item.name}</h2>
                    <p className="text-gray-600 text-sm mb-2 line-clamp-3">{item.description}</p>
                    <p className="font-semibold">Rs. {item.price}</p>
                  </div>

                  <div className="flex items-center gap-3 mt-4 sm:mt-0">
                    <button
                      onClick={() => handleDecrease(item)}
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded transition"
                      aria-label={`Decrease quantity of ${item.name}`}
                    >
                      -
                    </button>
                    <span className="text-lg font-medium">{item.quantity}</span>
                    <button
                      onClick={() => handleIncrease(item)}
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded transition"
                      aria-label={`Increase quantity of ${item.name}`}
                    >
                      +
                    </button>
                    <button
                      onClick={() => handleRemove(item.id)}
                      className="ml-4 text-red-600 hover:text-red-800 font-semibold"
                      aria-label={`Remove ${item.name} from cart`}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Special Instructions */}
      <div className="mt-8">
        <label htmlFor="instructions" className="block text-lg font-semibold mb-2">
          Special Instructions
        </label>
        <textarea
          id="instructions"
          rows="4"
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          placeholder="Add any special requests or instructions here..."
          className="w-full border border-gray-300 rounded p-3"
        ></textarea>
      </div>

      {/* Price Summary */}
      <div className="mt-10 border-t pt-6 space-y-3 text-right">
        <div className="flex justify-between text-gray-700">
          <span>Subtotal</span>
          <span>Rs. {subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-gray-700">
          <span>Delivery Fee</span>
          <span>Rs. {deliveryFee.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-bold text-xl mt-4">
          <span>Total</span>
          <span>Rs. {total.toFixed(2)}</span>
        </div>
      </div>

      {/* Checkout Button */}
      <div className="mt-8 text-right">
        <Link
          to={cartItems.length > 0 ? "/payment" : "#"}
          className={`px-6 py-3 rounded-lg font-semibold transition inline-block ${
            cartItems.length > 0
              ? "bg-blue-600 hover:bg-blue-700 text-white"
              : "bg-gray-400 cursor-not-allowed text-white"
          }`}
          onClick={(e) => {
            if (cartItems.length === 0) e.preventDefault();
          }}
        >
          Proceed to Checkout
        </Link>
      </div>
    </div>
  );
};

export default Cart;
